import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { UserAuthenticationService } from '../../../../../../libs/administration/src/lib/services/user-authentication.service';
import { Injectable, inject } from '@angular/core';
import { ErpSsoService } from '../../authentication-module/erp-sso.service';
@Injectable({
  providedIn: 'root'
})
class RoleAccessGuardService {
  constructor(
    private _sso: ErpSsoService,
    private authService: UserAuthenticationService
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const userModuleRoles = this.authService.getUser()?.userModuleRoles ?? [];
    const userModulesMetadata = userModuleRoles.map((x: any) => JSON.parse(x.module.metadata));
    const userModulesMetadataWithModuleId = userModuleRoles.map((x: any) => ({
      moduleId: x.module.moduleId,
      role: x.role,
      metadata: JSON.parse(x.module.metadata)
    }));

    const routeData = next.data;
    const moduleData = routeData['module'];
    const routeModule = userModulesMetadata.find((x: any) => x.label === moduleData);

    // The stored user has no CRM role. Sign in again: the ERP hand-off gives an up-to-date user, or says there
    // is no CRM access. (Sending them to the login route would bounce straight back here.)
    if (!routeModule) {
      this._sso.restartSignIn(state.url);
      return false;
    }

    const routeModuleRole = userModulesMetadataWithModuleId.find((x: any) => x.metadata.label === routeModule.label);

    if (routeModuleRole) {
      this.authService.UserSelectedModule = routeModule;
      this.authService.UserModule = userModulesMetadata;
      this.authService.setUserRole({
        displayName: routeModuleRole.role.displayName,
        roleId: routeModuleRole.role.roleId,
        roleName: routeModuleRole.role.roleName
      });
      return true;
    }

    this._sso.restartSignIn(state.url);
    return false;
  }
}
export const RoleAccessGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return inject(RoleAccessGuardService).canActivate(next, state);
};
